import { useFormik } from 'formik';
import { Box, Link, Stack, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { SignInValidationSchema } from 'utils/validation';
import { signIn } from 'store/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Layout as AuthLayout } from '../../layouts/auth/Layout';

const Login = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store: any) => store.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.authInfo.isAuthorized) {
      navigate('/');
    }
  }, [navigate, auth.authInfo?.isAuthorized]);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      submit: null,
    },
    validationSchema: SignInValidationSchema,
    onSubmit: async (values, helpers) => {
      try {
        dispatch(signIn({ email: values.email, password: values.password }));
      } catch (err: any) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <AuthLayout>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          flex: '1 1 auto',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: 550,
            px: 3,
            py: '100px',
            width: '100%',
          }}
        >
          <div>
            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography variant='h4'>Login</Typography>
              <Typography color='text.secondary' variant='body2'>
                Don&apos;t have an account? &nbsp;
                <Link href='/auth/signup' underline='hover' variant='subtitle2'>
                  Register
                </Link>
              </Typography>
            </Stack>
            <form noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  error={!!(formik.touched.email && formik.errors.email)}
                  fullWidth
                  helperText={formik.touched.email && formik.errors.email}
                  label='Email Address'
                  name='email'
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type='email'
                  value={formik.values.email}
                />
                <TextField
                  error={!!(formik.touched.password && formik.errors.password)}
                  fullWidth
                  helperText={formik.touched.password && formik.errors.password}
                  label='Password'
                  name='password'
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type='password'
                  value={formik.values.password}
                />
              </Stack>
              {formik.errors.submit && (
                <Typography color='error' sx={{ mt: 3 }} variant='body2'>
                  {formik.errors.submit}
                </Typography>
              )}
              <LoadingButton
                disabled={auth.authInfo?.isAPIInProgress}
                loading={auth.authInfo?.isAPIInProgress}
                fullWidth
                size='large'
                sx={{ mt: 3 }}
                type='submit'
                variant='contained'
              >
                Login
              </LoadingButton>
              <Box style={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: 10 }}>
                <Link href='/auth/forgot-password' underline='hover' variant='subtitle2'>
                  Forgot Password
                </Link>
              </Box>
            </form>
          </div>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default Login;
